import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../styles/SetPassword.css"; // Reuse styling
import "../styles/CheckInbox.css"; // Create this if needed

const CheckInbox = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email || "your email";

  const openEmailClient = () => {
    window.open("https://mail.google.com", "_blank");
  };

  return (
    <div className="setpassword-container">
      {/* Left Visual Panel */}
      <div className="setpassword-left">
        <img src="/log-img.png" alt="Reset Illustration" className="signup-image" />
        <img src="/star-icon.svg" alt="Star" className="star-icon star-icon-top" />
        <img src="/blue-star-icon.svg" alt="Blue Star" className="star-icon star-icon-bottom" />
        <div className="white-circle"></div>
        <div className="setpassword-badge track">
          <img src="/track-icon.svg" alt="Track Icon" />
          <p>Track & Manage <br />document on the go!</p>
        </div>
        <div className="white-circle-bottom"></div>
        <div className="white-circle-bottom-right"></div> 
        <div className="white-circle-bottom-right-up"></div> 
        <div className="setpassword-badge speed">
          <img src="/speed-icon.svg" alt="Speed Icon" />
          <p>Gain speed with <br/>your document delivery 🚀</p>
        </div>
        <div className="setpassword-badge dispatch">
          <img src="/dispatch-icon.svg" alt="Dispatch Icon" />
          <p>Dispatch your Cheques <br />from anywhere</p>
        </div>
      </div>

      {/* Right Message Panel */}
      <div className="setpassword-right">
        <div className="setpassword-wrapper">
          <div className="setpassword-card checkinbox-card">
            <h2 className="setpassword-title">Check your inbox 📩</h2>
            <p className="setpassword-subtext">
              We've sent a link to set a new password<br />
              to <em>{email}</em>
            </p>

            <button className="setpassword-button" onClick={openEmailClient}>
              Open email
            </button>

            <p className="setpassword-subtext link-text">
              Didn't get the email?{" "}
              <span className="login-link" onClick={() => navigate("/forgot-password")}>
                Try again
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckInbox;
